import React, { lazy, Suspense } from 'react';

const LazyFacility = lazy(() => import('./Facility'));

const Facility = (
  props: JSX.IntrinsicAttributes & { children?: React.ReactNode }
) => (
  <Suspense fallback={null}>
    <LazyFacility {...props} />
  </Suspense>
);

export default Facility;
